@import "../../../design-system/styles/constants.scss";

.integration-details-instances-wrapper {
  width: 100%;

  .instances-list-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: var(--spacing-4);

    & > :first-child {
      margin-right: auto;
    }
  }
}
